import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AuthService } from "./auth.service";
import { Globals } from "../shared/globals";

@Injectable()
export class ActivationService {

  constructor(private http: HttpClient,
    private authService: AuthService,
    private globals: Globals) { }

  activate(stationId: string, connectorId: number, durationInSeconds: number): Promise<number> {
    return this.authService.getToken().then((token) => {
      return this.performActivateConnectorRequest(
        token,
        stationId,
        connectorId,
        durationInSeconds
      );
    });
  }

  deactivate(stationId: string, connectorId: number): Promise<number> {
    return this.authService.getToken().then((token) => {
      return this.performDeactivateConnectorRequest(
        token,
        stationId,
        connectorId
      );
    });
  }

  // Internal methods

  private performActivateConnectorRequest(
    token: string,
    stationId: string,
    connectorId: number,
    durationInSeconds: number): Promise<number> {

    const url = this.globals.apiUrl('Chargings')
      + '?stationId=' + stationId
      + '&connector=' + connectorId.toString()
      + '&duration=' + durationInSeconds;

    return new Promise((resolve, reject) => {
      this.http
        .post(url.toString(), null, { headers: this.authService.headers(token) })
        .toPromise()
        .then((response) => {
          resolve(Number(response));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  private performDeactivateConnectorRequest(
    token: string,
    stationId: string,
    connectorId: number): Promise<number> {

    const url = this.globals.apiUrl('Chargings')
      + '?id=' + stationId
      + '&connector=' + connectorId.toString();

    return new Promise((resolve, reject) => {
      this.http
        .delete(url.toString(), { headers: this.authService.headers(token) })
        .toPromise()
        .then((response) => {
          resolve(Number(response));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

}
